import { useLocation, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import getQuery from '../helper/getQuery';

function useRouter(){
  const router = useLocation();
  let history = useHistory();
  const query = getQuery();
  const params = useParams();
  const match = useRouteMatch();
  return (
    {
      ...router,
      pathname: match.path,
      asPath: router.pathname,
      query: {
        ...query,
        ...params,
      },
      ...history,
      isExact: match.isExact
    }
  )
}

export default useRouter;